import React, { useEffect, useState } from 'react';
import { ChakraProvider, theme, Flex, Image, Text, Button } from '@chakra-ui/react';
import PhotoIcon from '../assets/img/photo_icon.svg';
import CartIcon from '../assets/img/cart.svg';
import StarIcon from '../assets/img/star_main.svg';
import EventImg from '../assets/img/event1.png';
import LandingImg from '../assets/img/landing.png';
import StarCheckIcon from '../assets/img/star_check.svg';
import DeleteIcon from '../assets/img/delete.svg';
import { getMyEvents } from '../apis/Events';
import { useHistory } from 'react-router';
import { useStoreActions, useStoreState } from 'easy-peasy';
const Events = (props) => {
    const [eventsCollection, setEventsCollection] = useState([])
    const userAPI = useStoreState(state => state.userProfile.api_key)
    const userProfile = useStoreState(state => state.userProfile);
    const isUserLogged = useStoreState(state => state.isUserLogged);
    const updateProfileId = useStoreActions(action => action.handleUserProfileId);
    const history = useHistory()

    function fetchMyEvents() {
        getMyEvents(userProfile.api_key).then(response => {
            (!response.error) ? setEventsCollection(response.data) : alert(`Error : ${response.message}`);
        })
    }

    function handleEvent(event, userProfileId) {
        if (isUserLogged) {
            updateProfileId(userProfileId)
            setTimeout(() => history.push(`${process.env.PUBLIC_URL}/showroom/${event.event_id}`), 0);
        } else {
            history.push(`${process.env.PUBLIC_URL}/event/${event.event_id}`);
        }
    }

    useEffect(() => {
        setTimeout(() => { fetchMyEvents() }, 0);
    }, [])

    // var ImgArray = [
    //     {
    //         "ID": "001",
    //         "Thumbnail": "https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__340.jpg",
    //         "Image": EventImg
    //     },{
    //         "ID": "002",
    //         "Thumbnail": "https://cdn.pixabay.com/photo/2018/01/14/23/12/nature-3082832__480.jpg",
    //         "Image": LandingImg
    //     },{
    //         "ID": "003",
    //         "Thumbnail": "https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__340.jpg",
    //         "Image": EventImg
    //     },{
    //         "ID": "004",
    //         "Thumbnail": "https://www.industrialempathy.com/img/remote/ZiClJf-1920w.jpg",
    //         "Image": LandingImg
    //     },{
    //         "ID": "005",
    //         "Thumbnail": "https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__340.jpg",
    //         "Image": EventImg
    //     },{
    //         "ID": "006",
    //         "Thumbnail": "https://cdn.pixabay.com/photo/2018/01/14/23/12/nature-3082832__480.jpg",
    //         "Image": LandingImg
    //     },{
    //         "ID": "007",
    //         "Thumbnail": "https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__340.jpg",
    //         "Image": EventImg
    //     },{
    //         "ID": "008",
    //         "Thumbnail": "https://www.industrialempathy.com/img/remote/ZiClJf-1920w.jpg",
    //         "Image": LandingImg
    //     },{
    //         "ID": "009",
    //         "Thumbnail": "https://cdn.pixabay.com/photo/2018/01/14/23/12/nature-3082832__480.jpg",
    //         "Image": EventImg
    //     }
    // ];

    return (
        <React.Fragment>
            <ChakraProvider theme={theme}>
                <Flex className="screen-detect-cntr2" justifyContent="center" alignItems="center" flexFlow="column">
                    <Flex className="screen-detect2" flexFlow="column">
                        <Flex flexDirection="column" bg="#f5f5f5" >

                            <Flex flexDirection="column" bg="white" pt="8" pb="4" mb="3">
                                <Text
                                    ml="4"
                                    fontSize="14px"
                                    fontWeight="400"
                                    color="#222222"
                                >Welcome back to Memzo</Text>
                                {/* <Button mt="4"
                                    fontSize="15px"
                                    fontWeight="700"
                                    border="1px solid #FA2F45"
                                    color="#FA2F45"
                                    bg="white"
                                    mr="4"
                                    ml="4"
                                    h="10"
                                    borderRadius="20">Find Event</Button> */}
                                    </Flex>
                            {(eventsCollection?.length > 0) ?
                                eventsCollection.map((item, index) =>
                                    <Flex className='ps-desktop-max-width-500' onClick={e => handleEvent(item, item.user_profile_id)} pl="2" pr="2" flexDirection="column" alignItems="center" key={index} >
                                        <Image
                                            fallbackSrc="https://www.freecodecamp.org/news/content/images/2020/05/loading-animation.gif"
                                            src={item.event_image_url}
                                            alt="Landing Icon"
                                            objectFit="cover"
                                            borderRadius="30px"
                                            h="220px"
                                            w="100%"
                                            p="3"
                                        />

                                        <Flex boxShadow="0px 10px 40px #0000000d" flexDirection="row" mt="-7" mb="3" w="95%" bg="white" pl="3" pr="3" pb="4" borderRadius="20" alignItems="center">
                                            <Flex
                                                w="138px"
                                                h="116px"
                                                borderRadius="100px"
                                                overflow="hidden">
                                                <Image
                                                    fallbackSrc="https://www.freecodecamp.org/news/content/images/2020/05/loading-animation.gif"
                                                    mt="4"
                                                    src={item.profile_selfie}
                                                    alt="Loader Icon"
                                                    borderRadius="180px"
                                                    w="100%"
                                                    h="100%"
                                                    objectFit="cover"
                                                /></Flex>
                                            <Flex flexDirection="column" pt="2" w="100%" pl="2" pb=".5">
                                                <Text
                                                    pt="4"
                                                    pl="3"
                                                    fontSize="20px"
                                                    fontWeight="700"
                                                    color="#222222">{item.event_name}</Text>

                                                <Flex flexDirection="row" alignItems="center" ml="4" mt="2">
                                                    {(item.all_photos_count) ? (<><Image
                                                        src={PhotoIcon}
                                                        alt="User Icon"
                                                        w="20px"
                                                        h="20px"
                                                        objectFit="contain" /><Text
                                                            pl="2"
                                                            fontSize="12px"
                                                            fontWeight="400"
                                                            color="#000000">{item.all_photos_count} Photos</Text></>) : ''}
                                                </Flex>
                                                <Flex flexDirection="row" alignItems="center" ml="4" mt="2">
                                                    {(item.cart_photos_count) ? (<><Image
                                                        src={CartIcon}
                                                        alt="User Icon"
                                                        w="20px"
                                                        h="20px"
                                                        objectFit="contain" /><Text
                                                            pl="2"
                                                            fontSize="12px"
                                                            fontWeight="400"
                                                            color="#000000">{item.cart_photos_count} Photos</Text></>) : ''}
                                                </Flex>

                                                <Flex flexDirection="row" alignItems="center" ml="4" mt="2" justifyContent="space-between">
                                                    {(item.all_photos_count) ? <Flex flexDirection="row" alignItems="center">
                                                        <Image
                                                            src={StarIcon}
                                                            alt="User Icon"
                                                            w="20px"
                                                            h="20px"
                                                            objectFit="contain"
                                                        />
                                                        <Image
                                                            src={StarCheckIcon}
                                                            alt="User Icon"
                                                            ml="5px"
                                                            w="2.5"
                                                            h="2.5"
                                                            position="absolute"
                                                            objectFit="contain"
                                                        />
                                                        <Text
                                                            pl="2"
                                                            fontSize="12px"
                                                            fontWeight="400"
                                                            color="#000000">{item.purchased_photos_count} Photos</Text>
                                                    </Flex> : ''}
                                                    {/* <Image
            src={DeleteIcon}
            alt="User Icon"
            w="3.5"
            h="3.5"
            objectFit="contain"
            /> */}
                                                </Flex></Flex></Flex>
                                    </Flex>)
                                :
                                <Flex flexDirection="column" mt="50%" mb="50%" alignItems="center" justifyContent="center">
                                    <Button isLoading colorScheme="teal" color="#FA2F45" disabled={false} variant="ghost" loadingText="Please Wait"></Button>
                                </Flex>
                            }
                        </Flex></Flex></Flex>
            </ChakraProvider>
        </React.Fragment>
    )
}

export default Events;
